import {OnlineOrderList} from '@/containers'
import {PageContainer} from '@/components/organisms'
import {PageHeader} from 'pepsico-ds'
import {useState} from 'react'
import {Tab, TabsNavigation} from '@/components/atoms'

export const OnlineOrder = () => {
  return (
    <div>
      <div className="flex flex-row justify-between">
        <PageHeader title="Order List" />
      </div>
      <PageContainer data-testid="online-order-page-content">
        <OnlineOrderTableEmbeddedInNavigation />
      </PageContainer>
    </div>
  )
}

const OnlineOrderTableEmbeddedInNavigation = () => {
  const [selectedTabIndex, setSelectedIndex] = useState(0)
  const handleNavigationUpdate = newIndex => {
    setSelectedIndex(newIndex)
  }

  return (
    <>
      <TabsNavigation handleSetActiveTab={handleNavigationUpdate} activeTabIndex={selectedTabIndex} className="mb-5">
        <Tab className="text-white" label="Online" />
        <Tab className="text-white" label="Offline" />
      </TabsNavigation>
      {selectedTabIndex === 0 && <OnlineOrderList />}
      {selectedTabIndex === 1 && <span>Offline content to be displayed</span>}
    </>
  )
}
